<template>
  <div class="myConsultant" v-if="consultantInfo.name">
    <div class="myConsultantWrap">
      <el-popover popper-class="popper-con" placement="left" width="285" trigger="hover">
        <span
          class="avatar"
          slot="reference"
          :style="{ backgroundImage: `url(${consultantInfo.idCardAbsolutePath})` }"
        />
        <div class="myConsultantInfo">
          <div class="consultant">
            <span class="name">{{ consultantInfo.name }}</span>
            <span class="phone">
              <img src="@/assets/imgs/icon-phone.png" alt="" />{{ consultantInfo.phoneNo | formatPhone }}
            </span>
            <span class="tip hoverAnt" @click="handleLink">扫码联系我的顾问<i class="el-icon-arrow-right"/></span>
          </div>
          <img class="qrCode" :src="consultantInfo.wechatQrCodeAbsolutePath" alt="" />
        </div>
      </el-popover>
      <!-- 内页自带返回顶部功能 -->
      <span class="line"></span>
      <img class="goTop hoverAnt" @click="handleTop" src="@/assets/imgs/icon-goTop.png" alt="" />
    </div>
  </div>
</template>

<script>
import { queryCounselor } from '@/api/firstpage';

export default {
  data() {
    return {
      consultantInfo: {},
    };
  },
  mounted() {
      const enterpriseId = this.$store.state.user.user.enterpriseId;
      queryCounselor({ enterpriseId }).then(res => {
        if (res) this.consultantInfo = res;
      });
  },
  methods: {
    handleTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    handleLink() {
      this.$router.push({ name: 'myCounselor' });
    },
  },
};
</script>

<style lang="less" scoped>
.myConsultant {
  position: fixed;
  z-index: 999;
  top: 80%;
  right: 30px;
  transform: translateY(-50%);
  .myConsultantWrap {
    display: flex;
    align-items: center;
    flex-direction: column;
    box-sizing: border-box;
    width: 58px;
    font-size: 14px;
    color: #aaa;
    border-radius: 35px;
    background: rgba(0, 0, 0, 0.6);
    box-shadow: 0px 10px 20px -5px rgba(0, 0, 0, 0.06);
  }
  .avatar {
    display: block;
    width: 58px;
    height: 58px;
    box-sizing: border-box;
    border: 4px solid #fff;
    border-radius: 50%;
    background-position: center;
    background-size: cover;
  }
  .line {
    width: 35px;
    height: 1px;
    margin: 16px auto 20px;
    background: #dcdce1;
    opacity: 0.3;
  }
  .goTop {
    width: 31px;
    margin-bottom: 25px;
  }
}
.myConsultantInfo {
  display: flex;
  justify-content: space-between;
  padding: 12px;
  border-radius: 15px;
  .consultant {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 15px;
    padding-left: 16px;
    .name {
      font-size: 20px;
      font-weight: bold;
      color: #333;
      margin-bottom: 8px;
    }
    .phone {
      color: #333;
      margin-bottom: 8px;
      img {
        height: 15px;
        margin-right: 5px;
      }
    }
    .tip {
      display: flex;
      align-items: center;
      color: #e27c00;
      i {
        font-size: 12px;
        font-weight: bold;
      }
    }
  }
  .qrCode {
    box-sizing: border-box;
    width: 95px;
    height: 95px;
    border: 1px solid #e27c00;
  }
}
</style>

<style lang="less">
.el-popper.popper-con {
  transform: translateX(-20px);
  .popper__arrow {
    right: -20px !important;
    border-left-color: #fff !important;
    border-width: 16px 10px !important;
  }
}
</style>
